import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';

export const NotifyBodayCtwo = () => {
    const breadcrumbLinks = [       
        { path: '/', label: 'Home' },
        { label: 'Notified Body Transition Details', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Notified Body Transition Details" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />

<section className="service-details section-space">
  <div className="container">
    <div className="row flex-xl-row flex-column-reverse">
      <div className="col-xl-4">
        <div className="sidebar sidebar-rr-sticky">
          <div className="sidebar__widget-service mb-30">
            <Link to="/service">
              Medical Device Manufacturers <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/pharmaceutical-details">
              Pharmaceutical & Biotech industry <i className="fa-solid fa-plus"></i>
            </Link>
            <Link to="/healthcare-details">
              Healthcare Providers <i className="fa-solid fa-plus"></i>
            </Link>
          </div>

          <div className="sidebar__widget-contact__service text-center">
            <h4 className="mb-25 title-animation text-capitalize">
              Are You ready to contact with us
            </h4>
            <p className="mb-20">
              <a href="tel:+86 19811976744">
                <i className="fa-solid fa-phone"></i>(+86) 19811976744
              </a>
            </p>

            <Link to="/contact-us#" className="rr-btn">
              <span className="btn-wrap">
                <span className="text-one">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
                <span className="text-two">
                  Contact Us <i className="fa-solid fa-plus"></i>
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className="col-xl-8">
        <div className="service-details__content">
          <div className="service-details__content-media mb-20">
            <img
              src="./assets/imgs/service-details/service-details-1.jpg"
              className="img-fluid"
              alt="img not found"
            />
          </div>
          <h2 className="title-animation mb-20">Notified Body Transition</h2>

<p className="mb-20">
  We offer a variety of solutions to efficiently manage transition projects. While each transition project is unique, our process remains consistent.
</p>
<h3 className="title-animation mb-20"> Medical Device Registration</h3>

<p className="mb-20">
Medical device registration involves obtaining regulatory approval to market a device in a specific region. This process ensures that the device meets safety, efficacy, and quality standards set by local authorities. Successful registration is crucial for legal market entry and ongoing compliance. 
</p>
        <h4 className="title-animation mb-15">
  How SQUARE MEDTECH Can Help in NMPA  Registration
</h4>
<ul className="mb-40">
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Regulatory Compliance Expertise
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Conducting a GAP analysis of your existing technical documentation.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Assisting with planning the required documentation for new products or projects.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Documentation Preparation and Update
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Providing support in creating all necessary technical documentation elements.
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Quality Management System (QMS) Integration
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Training and Support
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Cybersecurity and Software Documentation
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Post-Market Surveillance (PMS) and Vigilance Reporting
  </li>
  <li>
    <span>
      <i className="fa-solid fa-check"></i>
    </span>
    Submission and Liaison with Regulatory Bodies
  </li>
</ul>
          <h3 className="title-animation mb-20">NMPA Registration</h3>

          <p className="mb-20">
            The National Medical Products Administration (NMPA), formerly known as the China Food and Drug Administration (CFDA), is responsible for the regulation and approval of medical devices in China. Navigating the NMPA registration process is crucial for companies seeking to market their medical devices in the Chinese market.
          </p>

          <h3 className="title-animation mb-15">Detailed Overview of the Process</h3>
          <div className="content-container">
  <h3 className="section-title">
    <i className="fa-solid fa-check-circle text-success"></i> Documentation and Risk Classification
  </h3>
  <p className="section-description">Medical devices in China are classified into three risk categories:</p>

  <div className="classification-section">
    <h4 className="classification-title">
      <i className="fa-solid fa-shield text-primary"></i> Class I
    </h4>
    <p className="classification-description">Low-risk devices that require simple registration and self-declaration.</p>

    <h4 className="classification-title">
      <i className="fa-solid fa-exclamation-triangle text-warning"></i> Class II
    </h4>
    <p className="classification-description">Moderate-risk devices that require comprehensive technical documentation and conformity assessment.</p>

    <h4 className="classification-title">
      <i className="fa-solid fa-times-circle text-danger"></i> Class III
    </h4>
    <p className="classification-description">High-risk devices that require rigorous evaluation, including clinical trials and detailed technical documentation.</p>
  </div>

  <h3 className="section-title">
    <i className="fa-solid fa-check-circle text-success"></i> NMPA Registration Process
  </h3>

  <div className="step">
    <h4 className="step-title">
      <i className="fa-solid fa-list-ol text-info"></i> Determining Classification
    </h4>
    <p className="step-description">Determine the appropriate classification of the device based on the NMPA’s classification catalog.</p>
  </div>

  <div className="step">
    <h4 className="step-title">
      <i className="fa-solid fa-folder-open text-primary"></i> Preparation of Technical Documentation
    </h4>

    <div className="step-details">
      <p><i className="fa-solid fa-file-alt text-secondary"></i> <strong>Product Description:</strong> Detailed description of the device, including design, intended use, and labeling.</p>
      <p><i className="fa-solid fa-cogs text-secondary"></i> <strong>Quality Management System (QMS):</strong> Documentation demonstrating compliance with ISO 13485 or equivalent standards.</p>
      <p><i className="fa-solid fa-exclamation-circle text-secondary"></i> <strong>Risk Analysis:</strong> Comprehensive risk management report in accordance with ISO 14971.</p>
      <p><i className="fa-solid fa-flask text-secondary"></i> <strong>Preclinical and Clinical Data:</strong> Test reports, clinical evaluation reports, and clinical trial data (if applicable).</p>
      <p><i className="fa-solid fa-check-square text-secondary"></i> <strong>Standards Compliance:</strong> Evidence of compliance with applicable Chinese standards (GB/T standards).</p>
    </div>
  </div>

  <div className="step">
    <h4 className="step-title">
      <i className="fa-solid fa-vial text-info"></i> Local Testing
    </h4>
    <p className="step-description">Conduct testing at an NMPA-accredited testing laboratory in China, including electrical safety, biocompatibility, and performance testing.</p>
  </div>

  <div className="step">
    <h4 className="step-title">
      <i className="fa-solid fa-notes-medical text-danger"></i> Clinical Evaluation
    </h4>
    <div className="step-details">
      <p><i className="fa-solid fa-check-circle text-secondary"></i> For Class II and III devices, clinical trials may be required in China.</p>
      <p><i className="fa-solid fa-file-medical text-secondary"></i> <strong>Clinical Evaluation Report (CER):</strong> For some devices, a CER based on existing clinical data may suffice.</p>
    </div>
  </div>

  <div className="step">
    <h4 className="step-title">
      <i className="fa-solid fa-paper-plane text-primary"></i> Submission and Review
    </h4>
    <div className="step-details">
      <p><i className="fa-solid fa-file-upload text-secondary"></i> <strong>Dossier Submission:</strong> Submit the complete registration dossier to the NMPA.</p>
      <p><i className="fa-solid fa-microscope text-secondary"></i> <strong>Technical Review:</strong> NMPA conducts a thorough technical review of the submitted documents.</p>
      <p><i className="fa-solid fa-check-double text-secondary"></i> <strong>Administrative Review:</strong> Review of administrative compliance and documentation.</p>
    </div>
  </div>

  <div className="step">
    <h4 className="step-title">
      <i className="fa-solid fa-certificate text-success"></i> Approval and Certification
    </h4>
    <div className="step-details">
      <p><i className="fa-solid fa-award text-secondary"></i> <strong>Certificate Issuance:</strong> Upon successful review, the NMPA issues a registration certificate, valid for five years.</p>
      <p><i className="fa-solid fa-search text-secondary"></i> <strong>Post-Market Surveillance:</strong> Maintain compliance through regular post-market surveillance and reporting adverse events.</p>
    </div>
  </div>
</div>
          <p className="mb-30">
            <strong>SQUARE MEDTECH Expertise:</strong> The SQUARE MEDTECH team offers extensive experience and expertise in navigating the NMPA registration process for medical devices, enabling manufacturers to successfully enter and compete in the Chinese market.
          </p>

          <div className="row">
            <div className="col-lg-7">
              <div className="service-details__content-media-item service-details__content-media-item-1">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-2.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15">
                <i class="fa fa-circle-o text-danger"></i> Our Expertise in  NMPA registration 
                </h4>
                <p>
                At SQUARE MEDTECH, we specialize in NMPA (National Medical Products Administration) registration, offering in-depth knowledge of Chinese regulatory requirements. Our team provides end-to-end support, from document preparation to submission, ensuring timely approval and market access. Trust our expertise to navigate the complexities of NMPA regulations with confidence.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="service-details__content-media-item service-details__content-media-item-2">
                <div className="service-details__content-media-item_img mb-10">
                  <img
                    src="./assets/imgs/service-details/service-details-3.jpg"
                    className="img-fluid"
                    alt="img not found"
                  />
                </div>
                <h4 className="title-animation mb-15">
                <i class="fa fa-circle-o text-danger"></i> Why Choose Us for  NMPA  registration 
                </h4>
                <p>
                Choose SQUARE MEDTECH for NMPA  registration because of our expert guidance, streamlined process, compliance expertise, and commitment to ensuring your products meet NMPA  requirements efficiently and effectively.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


    </main>





<section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Service for Product Registration</h4>
                        <ul  class="color-white mb-0">
                        <li>Clinical Evaluation</li>
                        <li>Clinical Investigation </li>
                        <li>Regulatory Life Cycle</li>

                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                        <h4 class="color-white mb-15 mb-10">Our Service for Product Registration</h4>
                        <ul  class="color-white mb-0">
                        <li>PMCF Solution</li>
                        <li>Healthcare Survey</li>
                        <li>  EU MDR/FDA/ NMPA Consulting</li>
                      </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

    <FooterWhite/>

    </>
  )
}
